import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

class SelectMotivoTrasladoItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
      texto: '',
    };

    this.buscarMotivosTraslados = debounce(this.buscarMotivosTraslados.bind(this), 300);
  }

  componentDidMount() {
    // Cargar los primeros 10 al abrir por primera vez
    this.buscarMotivosTraslados('');
  }

  componentDidUpdate(prevProps) {
    if(prevProps.value !== this.props.value) {
      // Si el valor cambia, reiniciar las opciones
      if(this.props.value){
        const buscarMotivoTraslado = this.state.opciones.find(motivoTraslado => motivoTraslado._id.toString() === this.props.value.toString());
        if (!buscarMotivoTraslado){
          this.buscarMotivosTraslados(this.props.value || '', true);
        }
      }
    }
  }

  async buscarMotivosTraslados(texto, inicial, append = false) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "motivosTraslado/selectMotivoTrasladoItem",
        {
          empresaId: this.props.empresaId,
          query: append ? (this.state.texto || texto || this.props.value) : (texto || this.props.value),
          skip: append ? this.state.opciones.length : 0,   // saltar los ya cargados
        },
        {
          headers: this.props.headersToken,
        }
      );

      if (res.data.success === 2) {
        this.setState((prev) => ({
          opciones: append ? [...prev.opciones, ...res.data.motivosTraslado] : res.data.motivosTraslado,
          primerCarga: false,
          texto: append ? this.state.texto : texto
        }));
        if(this.props.puntoVenta && inicial) {
          this.props.onChange(res.data.motivosTraslado[0]?._id, res.data.motivosTraslado[0]);
        }
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar motivos de traslado:", error);
      this.setState({ opciones: [], texto: append ? this.state.texto : texto });
    } finally {
      // Asegurar que siempre se quite el loading
      this.setState({ cargando: false, texto: append ? this.state.texto : texto });
    }
  }


  render() {
    const {
      noBuscar,
      mode,
      selectAll,
      mostrarCarga,
      onSelectAll,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      onSearch: this.buscarMotivosTraslados,
      // Mostrar loading cuando está cargando, o mensaje cuando no hay resultados
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: 'center', padding: '8px' }}>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
            Buscando motivos de traslado...
          </div>
        </div>
      ) : this.state.primerCarga ? 'No se encontraron motivos de traslado' : null,
      // Mostrar loading en el input del select
      loading: this.state.cargando,
    };

    if (mode === 'multiple') {
      propsNuevas.maxTagCount = 'responsive';
    }

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? (fondoBlanco ? 'white' : 'white') : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };


    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const motivoTraslado = this.state.opciones.find((motivoTraslado) => motivoTraslado._id === value);
          this.props.onChange(value, motivoTraslado)
        }}
        placeholder={this.state.cargando && !this.state.primerCarga ? "Cargando..." : placeholder}
        style={estiloFinal}
        bordered={false}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            // Llegaste al fondo → cargar más
            this.buscarMotivosTraslados(this.props.value || '', false, true);
          }
        }}
      >
        {this.state.opciones.map((motivoTraslado) => (
          <Option key={motivoTraslado._id} value={motivoTraslado._id}>
            {motivoTraslado.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectMotivoTrasladoItem;